import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { MatButton, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/libraries/globals';
import { CapacitacionesService } from 'src/app/services/capacitaciones/capacitaciones.service';
import { Dialogs } from 'src/app/ui/dialogs/dialogs';
import { Wait } from 'src/app/ui/wait/Wait';

@Component({
  selector: 'app-capacitaciones-index-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class CapacitacionesIndexEditComponent implements OnInit, AfterViewInit {

  @ViewChild('mainContainer', {static:false}) mainContainer : ElementRef;
  @ViewChild('btnGuardar', {static:false})    btnGuardar    : MatButton;
  @ViewChild('btnCerrar', {static:false})     btnCerrar     : MatButton;
  @ViewChild('ngFormGroup', {static:false})   ngFormGroup   : FormGroupDirective;

  @Output('onChange') onChange : EventEmitter<any> = new EventEmitter<any>();
  
  private boolGuardar : boolean = false;
  private objDialogs  : Dialogs = new Dialogs();
  private formGroup   : FormGroup;

  private lstRepresentantesLegales      : Array<any> = [];
  private lstRepresentantesTrabajadores : Array<any> = [];

  public objData : any = null;

  constructor(private objDialogRef : MatDialogRef<CapacitacionesIndexEditComponent>, 
              private objCapacitacionesService : CapacitacionesService,
              private toastr: ToastrService) { }

  ngOnInit() {

    this.formGroup = new FormGroup({
      'representanteLegal'      : new FormControl(null),
      'representanteTrabajador' : new FormControl(null),
      'showLogoDC3'             : new FormControl(false)
    });

  }

  ngAfterViewInit() {
    this.edit();
  }

  // EVENTOS
  close()
  {
    if(!this.boolGuardar)
    {
      this.objDialogRef.close();
    }
  }

  btnGuardar_clickEvent()
  {
    this.update();
  }

  // METODOS
  private loading(value : boolean) {
    if(value) {

      Wait.show(this.mainContainer, "Guardando...");
      this.btnGuardar.disabled        = true;
      this.btnCerrar.disabled         = true;
      this.boolGuardar                = true;
      this.objDialogRef.disableClose  = true;

    } else{

      Wait.hide(this.mainContainer);
      this.btnGuardar.disabled        = false;
      this.btnCerrar.disabled         = false;
      this.boolGuardar                = false;
      this.objDialogRef.disableClose  = false;

    }
  }

  private edit() : void {

    let objCapacitacion : any =
    {
      idCliente : this.objData.idCliente
    };

    this.objCapacitacionesService.edit(objCapacitacion)
    .subscribe( objResponse => {
      
      if(objResponse.session) {

        if(objResponse.action) {

          this.lstRepresentantesLegales       = objResponse.result.representantesLegales;
          this.lstRepresentantesTrabajadores  = objResponse.result.representantesTrabajadores;

          var hasRL = this.lstRepresentantesLegales.some(x => x.idClienteContacto == this.objData.idRepresentanteLegal);
          var hasRT = this.lstRepresentantesTrabajadores.some(x => x.idClienteContacto == this.objData.idRepresentanteTrabajador);

          if(hasRL) {
            this.formGroup.controls["representanteLegal"].setValue(this.objData.idRepresentanteLegal);
          }

          if(hasRT) {
            this.formGroup.controls["representanteTrabajador"].setValue(this.objData.idRepresentanteTrabajador);
          }

          this.formGroup.controls["showLogoDC3"].setValue(this.objData.showLogoDC3);
          
        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }
      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }

    }, error => {

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });

  }

  private update() : void {

    this.loading(true);

    let objCapacitacion : any =
    {
      idCapacitacion            : this.objData.idCapacitacion,
      idRepresentanteLegal      : Globals.validValue(this.formGroup.controls["representanteLegal"].value) ? this.formGroup.controls["representanteLegal"].value : 0,
      idRepresentanteTrabajador : Globals.validValue(this.formGroup.controls["representanteTrabajador"].value) ? this.formGroup.controls["representanteTrabajador"].value : 0,
      showLogoDC3               : this.formGroup.controls["showLogoDC3"].value
    };

    this.objCapacitacionesService.update(objCapacitacion)
    .subscribe( objResponse => {
      
      if(objResponse.session) {

        if(objResponse.action) {
          
          this.objDialogRef.close();
          this.onChange.emit(this);
          this.toastr.success(objResponse.message, objResponse.title, { timeOut: 2000 });
          
        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }
      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }

      this.loading(false);

    }, error => {

      this.loading(false);

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });

  }

}
